/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var EquipmentState;
(function (EquipmentState) {
    EquipmentState["Available"] = "Available";
    EquipmentState["Mounted"] = "Mounted";
    EquipmentState["Removed"] = "Removed";
})(EquipmentState || (EquipmentState = {}));
export function EquipmentStateFromJSON(json) {
    return EquipmentStateFromJSONTyped(json, false);
}
export function EquipmentStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EquipmentStateToJSON(value) {
    return value;
}
